export const SUBMISSION_TRUST_RECOVERY_HEADING = 'Review before relying on this mark.';

export const TUTOR_SUBMISSION_TRUST_RECOVERY_COPY =
  'Use tutor override if the interpreted answer or method evidence is wrong. The original submission and automatic mark are preserved.';

export const STUDENT_SUBMISSION_TRUST_RECOVERY_COPY =
  'Tell your tutor if this mark looks wrong. If they ask for a clearer photo, retake it in better light and make sure all of your work is visible.';

export const TUTOR_SUBMISSION_RECOVERY_GUIDANCE = {
  replace_or_override:
    'If the image is missing, blurry, or incomplete, ask for a clearer upload before relying on this mark. If the work is readable and the interpreted answer or method evidence is wrong, use tutor override.',
  override_when_clear:
    "For multiple possible answers, use override only when the student's intended final answer or method evidence is clear from the work.",
  check_interpreted_answer:
    "Check the interpreted answer against the student's work. Use override only if it does not match the work or the method evidence.",
};

export const STUDENT_SUBMISSION_RECOVERY_GUIDANCE = {
  replace_or_override:
    'If the image is missing, blurry, or incomplete, tell your tutor and be ready to retake it in better light. If the work is readable but the mark looks wrong, ask your tutor to review it.',
  override_when_clear:
    'If more than one possible answer is visible, tell your tutor which answer you intended as final. Make that answer clear if they ask you to retake the photo.',
  check_interpreted_answer:
    'Check the interpreted answer against your work. If it does not match, tell your tutor and be ready to retake a clear photo.',
};

export const TUTOR_DEGRADED_PAGE_GUIDANCE =
  'If a page is missing, blank, or unreadable, ask for a clearer upload before relying on this mark.';

export const STUDENT_DEGRADED_PAGE_GUIDANCE =
  'If a page is missing, blank, or unreadable, tell your tutor and be ready to retake it in better light.';
